/**
 * Created by Jerker Nord on 2024-02-08.
 */
import {LonerGameAssets} from "../LonerGameAssets";
import {Loner} from "../Loner";
import {LonerSpine} from "../components/LonerSpine";

export class LonerPoolInfectedSymbolSpines {

    private _infectedSymbolSpines:LonerSpine[];

    public init():void {
        this._infectedSymbolSpines = [];
        for(let i:number = 0; i < 6; i++) {
            this._infectedSymbolSpines.push(this.createNewInfectedSpine());
        }
    }

    private createNewInfectedSpine():LonerSpine {
        const infectedSpine:LonerSpine = new LonerSpine(Loner.assetLoader.getSpineAsset(LonerGameAssets.SYMBOL_INFECTED_SPINE));
        infectedSpine.visible = false;
        Loner.symbolTopView.addChild(infectedSpine);
        return infectedSpine;
    }

    public getInfectedSymbolSpine():LonerSpine {
        for(let i:number = 0; i < this._infectedSymbolSpines.length; i++) {
            if(this._infectedSymbolSpines[i].isUsed == false) {
                this._infectedSymbolSpines[i].isUsed = true;
                return this._infectedSymbolSpines[i];
            }
        }
        this._infectedSymbolSpines.push(this.createNewInfectedSpine());
        return this.getInfectedSymbolSpine();
    }
}